export default{
    methods:{
        asyncLoad:function (link, id, listener = null) {
            var d = document;
            var s = 'script';
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) { if (listener != null) listener(false); return;}
            js = d.createElement(s); js.id = id;
            js.src = link;
            fjs.parentNode.insertBefore(js, fjs);

            js.addEventListener("load", function(event) {
                if (event.target.id === id){
                    if (listener != null) listener(true);
                }
            }, true);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/commons/util/AsyncLoader.js